<template>
  <div class="hardware-page">
    <a-row :gutter="16">
      <a-col :span="12" style="margin-bottom: 16px">
        <div class="module-container bg-module-container" style="height: 270px">
          <hardware-resource-card
            :data-source="psus"
            :data-count="psuCount"
            type="psu"
            v-if="psus !== undefined"
          >
            <span slot="titleText">电源</span>
            <monitor-icon
              slot="itemIcon"
              icon="power"
              style="font-size: 24px"
            ></monitor-icon>
          </hardware-resource-card>
        </div>
      </a-col>
      <a-col :span="12" style="margin-bottom: 16px">
        <div class="module-container bg-module-container" style="height: 270px">
          <hardware-resource-card
            :data-source="fans"
            :data-count="fanCount"
            type="fan"
            v-if="fans !== undefined"
          >
            <span slot="titleText">风扇</span>
            <monitor-icon
              slot="itemIcon"
              icon="fan"
              style="font-size: 24px"
            ></monitor-icon>
          </hardware-resource-card>
        </div>
      </a-col>
      <a-col :span="12" style="margin-bottom: 16px">
        <div class="module-container bg-module-container" style="height: 270px">
          <hardware-resource-card
            :data-source="temps"
            :data-count="tempCount"
            type="temp"
            v-if="temps !== undefined"
          >
            <span slot="titleText">温度</span>
            <monitor-icon
              slot="itemIcon"
              icon="temperature"
              style="font-size: 24px"
            ></monitor-icon>
          </hardware-resource-card>
        </div>
      </a-col>
      <a-col :span="12" style="margin-bottom: 16px">
        <div class="module-container bg-module-container" style="height: 270px">
          <hardware-resource-card
            :data-source="memorys"
            :data-count="memoryCount"
            type="memory"
            v-if="memorys !== undefined"
          >
            <span slot="titleText">内存</span>
            <monitor-icon
              slot="itemIcon"
              icon="memory"
              style="font-size: 24px"
            ></monitor-icon>
          </hardware-resource-card>
        </div>
      </a-col>
      <a-col :span="12" style="margin-bottom: 16px">
        <div class="module-container bg-module-container" style="height: 270px">
          <hardware-resource-card
            :data-source="disks"
            :data-count="diskCount"
            type="disk"
            v-if="disks !== undefined"
          >
            <span slot="titleText">物理磁盘</span>
            <monitor-icon
              slot="itemIcon"
              icon="disk"
              style="font-size: 24px"
            ></monitor-icon>
          </hardware-resource-card>
        </div>
      </a-col>
      <a-col :span="12" style="margin-bottom: 16px">
        <div class="module-container bg-module-container" style="height: 270px">
          <hardware-resource-card
            :data-source="diskArrays"
            :data-count="diskArrayCount"
            type="disk_array"
            v-if="diskArrays !== undefined"
          >
            <span slot="titleText">磁盘阵列</span>
            <monitor-icon
              slot="itemIcon"
              icon="disk_array"
              style="font-size: 24px"
            ></monitor-icon>
          </hardware-resource-card>
        </div>
      </a-col>
      <a-col :span="12" style="margin-bottom: 16px">
        <div class="module-container bg-module-container" style="height: 270px">
          <hardware-resource-card
            :data-source="cpus"
            :data-count="cpuCount"
            type="cpu"
            v-if="cpus !== undefined"
          >
            <span slot="titleText">CPU</span>
            <monitor-icon
              slot="itemIcon"
              icon="cpu"
              style="font-size: 24px"
            ></monitor-icon>
          </hardware-resource-card>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { humanizeValue } from '@/utils'
import {
  getServerPSUList,
  getServerTemperatureList,
  getServerFanList,
  getServerPhysicalDiskList,
  getServerMemoryList,
  getServerDiskArrayList,
  getServerCPUList,
  getServerMonitorItemList
} from '@/api/server'
import HardwareResourceCard from '@/components/source-detail-page/HardwareResourceCard'
import MonitorIcon from '@/components/icon/MonitorIcon'

export default {
  name: 'HardwarePage',
  components: {
    HardwareResourceCard,
    MonitorIcon
  },
  props: {
    detail: {
      type: Object
    }
  },
  data () {
    return {
      fans: [],
      fanCount: {
        normal: 0,
        abnormal: 0
      },
      psus: [],
      psuCount: {
        normal: 0,
        abnormal: 0
      },
      temps: [],
      tempCount: {
        normal: 0,
        abnormal: 0
      },
      disks: [],
      diskCount: {
        normal: 0,
        abnormal: 0
      },
      diskArrays: [],
      diskArrayCount: {
        normal: 0,
        abnormal: 0
      },
      memorys: [],
      memoryCount: {
        normal: 0,
        abnormal: 0
      },
      cpus: [],
      cpuCount: {
        normal: 0,
        abnormal: 0
      }
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.psus = []
      this.psuCount = {
        normal: 0,
        abnormal: 0
      }
      this.fans = []
      this.fanCount = {
        normal: 0,
        abnormal: 0
      }
      this.temps = []
      this.tempCount = {
        normal: 0,
        abnormal: 0
      }
      this.disks = []
      this.diskCount = {
        normal: 0,
        abnormal: 0
      }
      this.memorys = []
      this.memoryCount = {
        normal: 0,
        abnormal: 0
      }
      this.diskArrays = []
      this.diskArrayCount = {
        normal: 0,
        abnormal: 0
      }
      this.cpus = []
      this.cpuCount = {
        normal: 0,
        abnormal: 0
      }
      getServerPSUList(this.detail.id).then(res => {
        const data = res.data
        if (data && data.data.length) {
          data.data.forEach(item => {
            const obj = {
              id: item.id,
              name: item.name,
              index: item.index,
              status: item.status,
              value: 0,
              label: '功率',
              unit: item.unit ? item.unit : 'W',
              power: 0,
              updated_at: item.updated_at,
              created_at: item.created_at
            }
            const key = this.getKeys(item.index, 'psu')
            getServerMonitorItemList(this.detail.id, { key }).then(res => {
              obj.value =
                res.data && res.data.data.length ? res.data.data[0].value : '-'
              obj.power = obj.value
            })
            if (item.status === 'normal') this.psuCount.normal++
            else this.psuCount.abnormal++
            this.psus.push(obj)
          })
        } else this.psus = []
      })
      getServerMemoryList(this.detail.id).then(res => {
        const data = res.data
        if (data && data.data.length) {
          data.data.forEach(item => {
            const obj = {
              id: item.id,
              name: item.name,
              index: item.index,
              status: item.status,
              value: 0,
              size: '-',
              label: '容量',
              unit: item.unit ? item.unit : 'B',
              updated_at: item.updated_at,
              created_at: item.created_at
            }
            const key = this.getKeys(item.index, 'memory')
            getServerMonitorItemList(this.detail.id, { key }).then(res => {
              obj.value =
                res.data && res.data.data.length
                  ? humanizeValue(res.data.data[0].value)
                  : '-'
              obj.size = obj.value
            })
            if (item.status === 'normal') this.memoryCount.normal++
            else this.memoryCount.abnormal++
            this.memorys.push(obj)
          })
        } else this.memorys = []
      })
      getServerDiskArrayList(this.detail.id).then(res => {
        const data = res.data
        if (data && data.data.length) {
          this.diskArrays = data.data
          data.data.forEach(item => {
            if (item.status === 'normal') this.diskArrayCount.normal++
            else this.diskArrayCount.abnormal++
          })
        } else this.diskArrays = []
      })
      getServerFanList(this.detail.id).then(res => {
        const data = res.data
        if (data && data.data.length) {
          data.data.forEach(item => {
            const obj = {
              id: item.id,
              name: item.name,
              index: item.index,
              status: item.status,
              value: '-',
              label: '转速',
              unit: item.unit ? item.unit : 'rpm',
              speed: '-',
              updated_at: item.updated_at,
              created_at: item.created_at
            }
            const key = this.getKeys(item.index, 'fan')
            getServerMonitorItemList(this.detail.id, { key }).then(res => {
              obj.value =
                res.data && res.data.data.length ? res.data.data[0].value : '-'
              obj.speed = obj.value
            })
            if (item.status === 'normal') this.fanCount.normal++
            else this.fanCount.abnormal++
            this.fans.push(obj)
          })
        } else this.fans = []
      })
      getServerTemperatureList(this.detail.id).then(res => {
        const data = res.data
        if (data && data.data.length) {
          data.data.forEach(item => {
            const obj = {
              id: item.id,
              name: item.name,
              index: item.index,
              status: item.status,
              value: '-',
              label: '温度',
              unit: item.unit ? item.unit : '°C',
              updated_at: item.updated_at,
              created_at: item.created_at
            }
            const key = this.getKeys(item.index, 'temp')
            getServerMonitorItemList(this.detail.id, { key }).then(res => {
              obj.value =
                res.data && res.data.data.length ? res.data.data[0].value : '-'
            })
            if (item.status === 'normal') this.tempCount.normal++
            else this.tempCount.abnormal++
            this.temps.push(obj)
          })
        } else this.temps = []
      })
      getServerPhysicalDiskList(this.detail.id).then(res => {
        const data = res.data
        if (data && data.data.length) {
          data.data.forEach(item => {
            const obj = {
              id: item.id,
              name: item.name,
              index: item.index,
              status: item.status,
              value: '-',
              label: '容量',
              used: '-',
              size: '-',
              usage: 0,
              unit: item.unit ? item.unit : 'B',
              updated_at: item.updated_at,
              created_at: item.created_at
            }
            const keyArr = this.getKeys(item.index, 'disk')
            Promise.all(
              keyArr.map(async keyObj => {
                getServerMonitorItemList(this.detail.id, {
                  key: keyObj.key
                }).then(res => {
                  const v =
                    res.data && res.data.data.length
                      ? res.data.data[0].value
                      : '-'
                  if (keyObj.name === 'usage') {
                    obj[keyObj.name] = v * 1
                  } else {
                    obj[keyObj.name] = v === '-' ? '-' : humanizeValue(v)
                    if (keyObj.name === 'size') obj.value = obj[keyObj.name]
                  }
                })
              })
            ).then(() => {
              if (item.status === 'normal') this.diskCount.normal++
              else this.diskCount.abnormal++
              this.disks.push(obj)
            })
          })
        } else this.disks = []
      })
      getServerCPUList(this.detail.id).then(res => {
        const data = res.data
        if (data && data.data.length) {
          this.cpus = data.data
          data.data.forEach(item => {
            if (item.status === 'normal') this.cpuCount.normal++
            else this.cpuCount.abnormal++
          })
        } else this.cpus = []
      })
    },
    getKeys (index, type) {
      if (type === 'psu') return `sensor.psu.power[${index}]`
      if (type === 'fan') return `sensor.fan.speed[${index}]`
      if (type === 'temp') return `sensor.temp.value[${index}]`
      if (type === 'memory') return `memory.size[${index}]`
      if (type === 'disk') {
        return [
          { key: `physicaldisk.size[${index}]`, name: 'size' },
          { key: `physicaldisk.used[${index}]`, name: 'used' },
          { key: `physicaldisk.pused[${index}]`, name: 'usage' }
        ]
      }
    }
  }
}
</script>

<style lang="less">
.hardware-page {
  .module-container {
    position: relative;
    background: #fff;
    border-radius: 6px;
    padding: 16px 16px 8px 16px;
    overflow: hidden;
    border: 1px solid #e5e5e5;
    margin-right: 1px;

    header {
      font-size: 16px;
      font-weight: 500;
      color: #096dd9;
      line-height: 22px;
    }
  }
  .bg-module-container {
    position: relative;
    &::before {
      content: '';
      position: absolute;
      top: 0px;
      bottom: 0px;
      left: 0;
      width: 41.67%;
      border-right: 1px solid #f6fbfe;
      background: #f6fbfe;
    }
  }
}
</style>
